import React from 'react';
import { useTranslate } from '@tolgee/react';
import { Typography } from '@/components/Atoms';
import { GlobalStatsResponseType } from '@/types/GameLog/res';
import useWebSocket from '@/hooks/useWebSocket';

const GlobalStatsSection = () => {
  const { t } = useTranslate('commandCenter');
  const { messages } = useWebSocket<GlobalStatsResponseType>('wss://event-message.landrocker.io/get-player');
  return (
    <div className='col-span-12 xl:col-span-8 bg-[#3C3B3B] bg-opacity-40 rounded-[10px] px-2 py-1 lg:grid grid-cols-12 grid-rows-2 xl:grid-rows-1 h-full'>
      <div className='col-span-12 flex items-center'>
        <Typography size='s12ToS12' className='flex-shrink-0 font-bold'>
          {t('CENTER_SECTION.globalStateSection.title')}
        </Typography>
        <div className='w-full h-[1px] bg-[#4F4F4F] mx-4'></div>
      </div>
      <div className='col-span-12 w-full grid grid-cols-8 gap-y-2'>
        {messages?.player?.map((item, index) => {
          const key = Object.keys(item)[0];
          const { Key, Value } = item[key];
          return (
            <div key={index} className='col-span-3 md:col-span-2 lg:col-span-4'>
              <div className='xl:flex xl:flex-row xl:gap-2 xl:items-center'>
                <Typography Component='div' className='text-[#767676] text-[10px] md:text-[11px]'>
                  {Key}
                </Typography>
                <Typography Component='div' size='s14ToS12'>
                  <div>{Value}</div>
                </Typography>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GlobalStatsSection;
